import { BRDGE_PROJECT_ID } from "@/lib/config"

export const useOnboardingStore = defineStore(
  `onboarding_${BRDGE_PROJECT_ID}`,
  {
    state: (): {
      completed: boolean
      groupName: string | undefined
      guideId: number | undefined
    } => ({
      completed: false,
      groupName: undefined,
      guideId: undefined
    }),
    actions: {
      complete() {
        this.completed = true
      },
      setGroupName(groupName: string) {
        this.groupName = groupName
      },
      setGuideId(guideId: number) {
        this.guideId = guideId
      }
    },
    persist: {
      storage: piniaPluginPersistedstate.localStorage()
    }
  }
)
